import Vue from 'vue';
import App from './App';
import router from './router';
//import Axios from 'axios';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';  // 默认主题
//import 'element-ui/lib/theme-chalk/index.css';
import "@/assets/css/index.css";
Vue.use(ElementUI);
//Vue.use(ElementUI, { size: 'small' });

// import Pagination from 'vue-pagination-2'
// Vue.component('pagination', Pagination)


import qs from 'qs'; //引入qs模块

Vue.prototype.$qs = qs;


// import 'lib-flexible/flexible'

import Print from 'vue-print-nb'
	Vue.use(Print)

import "babel-polyfill"; // cnpm install babel-polyfill --save  在默认入口文件main.js里面引入   import 'babel-polyfill'
//import * as qiniu from 'qiniu-js'
import Storage from '@/components/libs/storage';
Vue.prototype.$IS_SHOW_VIEW = true;
Vue.prototype.$admininfo= {};
/**    $headimg= 默认头像|  $nopic= 无图 | $defaultImg= 默认图片      **/
Vue.prototype.$headimg = require('@/assets/img/ren.png')
// Vue.prototype.$nopic = require('@/assets/icon/nopic.svg')
Vue.prototype.$nopic = require('@/assets/icon/load-logo.png')
Vue.prototype.$defaultImg = require('@/assets/icon/nopic.svg')
Vue.prototype.GLOBAL = require('@/components/config/config')  // 引用公共配置信息
//Vue.prototype.GLOBAL = global_//挂载到Vue实例上面 this.GLOBAL.proxy_upload_url,//代理后的 上传图片URL

// 路由跳转
Vue.prototype.$goRoute = function(path){
          this.$router.push(path);
}

// Vue.prototype.$gotoUrl = function(path){
//           this.$router.push(path);
// }

// npm i vue-lazyload -S
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  // error: require('@/assets/icon/nopic.svg'), //图片路径错误时加载图片
  error: require('@/assets/icon/load-logo.png'), //图片路径错误时加载图片
  //加载时显示的GIF图
 // loading: require('@/assets/img/loading.png'), //预加载图片
   loading: require('@/assets/icon/loading.svg'), //预加载图片

  //尝试加载几次
  attempt: 2
});




// Vue.prototype.$axios = Axios;
// Vue.prototype.$qiniu = qiniu;
// Axios.defaults.baseURL = '/api';
// //Axios.defaults.headers.post['Content-Type'] = 'application/json';
// // 设置 POST 请求头
// Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// // 配置 CORS 跨域
// Axios.defaults.withCredentials = true;
// Axios.defaults.crossDomain = true;
// //2019-02-23
// Axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';



//Vue.config.productionTip = false;
//在代码中使用环境变量非常简单。例如：
//Vue.config.productionTip = false;
Vue.config.productionTip = process.env.NODE_ENV === 'production'
//============================== nginx conf
// location /api/ {
// proxy_http_version 1.1;
// rewrite ^/api(.*) /$1 break;
// proxy_pass https://api.XXXX.com;
// }
// #upload
// location /upload/ {
// proxy_http_version 1.1;
// rewrite ^/upload(.*) /$1 break;
// proxy_pass https://images.XXXX.com;
// }
// 2019-02-23
//==============================



Vue.prototype.$site = {};
//拦截所有路由跳转

  router.beforeEach((to, from, next) => {
      console.info("path:::::::::::",  to.path );
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    if (to.meta.content) {
        document.querySelector('meta[name="keywords"]').setAttribute("content", to.meta.content.keywords)
        document.querySelector('meta[name="description"]').setAttribute("content", to.meta.content.description)
    }
    next();

});


//使用钩子函数对路由进行权限跳转
// router.beforeEach((to, from, next) => {
// console.info("path:::::::::::",  to.path );
// if (to.meta.title) {
// document.title = to.meta.title
// }
// let role = '';
// const admininfo =  Storage.s_getItem("admin");//   let _userinfo = Storage.l_getItem('userinfo');
// Vue.prototype.$admininfo = admininfo;
// if( admininfo ==  null && to.path !== '/login'  ){
// console.info("登录窗口...");
// next('/login');
// }else if( admininfo ){
// role =  admininfo.username  ?  admininfo.username : null ;
// }
// if(!role && to.path !== '/login' ){
// console.info("登录窗口...");
// next('/login');
// }else if(to.meta.permission){
// console.info("如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已...");
// role === 'admin' ? next() : next('/403');
// }else{
// if(navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor'){
// Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
// confirmButtonText: '确定'
// });
// console.info('简单的判断IE10及以下不进入富文本编辑器，该组件不兼容');
// }else{
// next();
// }
// }
// });


new Vue({
    el: '#app',
    router,
    render: h => h(App),
    template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js